<template>
    <div>
        <Card>
            <p slot="title">
                Log Sms
            </p>

            <Row type="flex" justify="space-between" class="code-row-bg">
                <Col span="6">
                    <Select

                        placeholder="Ketik Marking"
                        v-model="markingIdSelected"
                        filterable
                        clearable
                        remote
                        :remote-method="getMarkingByCode"
                        :loading="loadingGetMarking"
                        >
                        <Option v-for="option in optionMarkings"
                            :value="option.value" :key="new Date()">{{option.label}}</Option>
                    </Select>

                </Col>
                <Col span="5">
                    <Date-picker v-model="fromDate"
                        clearable="false"
                        style="width: 110px;"
                        type="date"
                        placeholder=""
                        format="dd/MM/yyyy">
                    </Date-picker>
                    -
                    <Date-picker v-model="toDate"
                        clearable="false"
                        style="width: 110px;"
                        type="date"
                        placeholder=""
                        format="dd/MM/yyyy">
                    </Date-picker>
                </Col>
                <Col span="6">
                    <Button
                        type="primary"
                        :loading="loadingSearch"
                        @click="getSms"
                        icon="ios-search" >
                            <span v-if="!loadingSearch">Cari</span>
                            <span v-else>Wait.....</span>
                    </Button>
                </Col>
                <Col span="6">
                </Col>
            </Row>

            <br>

            <Table
                v-show="dataSms.length > 0"
                :columns="tableColumns"
                :data="dataSms"
                no-data-text=""
            ></Table>

        </Card>

    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'

const numeral = require('numeral');

export default {
    data () {
        return {

        markingIdSelected : '',
        optionMarkings : [],
        loadingGetMarking: false,
        loadingSearch : false,
        fromDate: Date.now(),
        toDate: Date.now(),
        dataSms : [],
        tableColumns: [
            {
                title: 'Tgl',
                key: 'smsDate',
                sortable: false
            },
            {
                title: 'Marking',
                key: 'markingheadercode',
                sortable: true
            },
            {
                title: 'To',
                key: 'to',
                sortable: false
            },
            {
                title: 'Pesan',
                key: 'message',
                sortable: false
            },
            {
                title: 'Status',
                align : 'right',
                key: 'status',
                sortable: false
            },
            {
                title: 'Updated At',
                align : 'right',
                key: 'updatedAt',
                sortable: false
            },
            {
                title: '',
                key: 'action',
                width: 120,
                align: 'center',
                render: (h, params) => {
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'success',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.show(params.index)
                                }
                            }
                        }, 'Resend')
                    ]);
                }
            }
        ],
        filterInput : ''

    }},
    //components : {HeaderTable},
    methods: {
        getSms: function(){
            this.loadingSearch = true;
            let urlLog = 'sms/showLog';
            let fixLogFromDate = '';
            if(this.fromDate != '') {
                fixLogFromDate = moment(this.fromDate).format('YYYY-MM-DD');
            }
            let fixLogToDate = '';
            if(this.toDate != '') {
                fixLogToDate = moment(this.toDate).format('YYYY-MM-DD');
            }
            HTTP
            .post(urlLog, {
                markingHeaderId: this.markingIdSelected,
                fromDate: fixLogFromDate,
                toDate: fixLogToDate,
            })
            .then(response => {
                console.log(response);
                let parent = this;

                let dataSms = []
                _.forEach(response.data, function(value) {
                    _.forEach(value, function(value){
                        let Sms = {
                            smsId : value.id,
                            smsDate : parent.showDateFormatted(value.created_at),
                            markingHeaderId : value.markingHeaderId,
                            markingheadercode : value.markingheadercode,
                            to : value.to,
                            message : value.message,
                            status : value.status,
                            updatedAt : parent.showDateFormatted(value.updated_at)
                        }
                        dataSms.push(Sms);
                    });
                });
                this.dataSms = dataSms;
                this.loadingSearch = false;
            })
            .catch(e => {
                this.loadingSearch = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        getMarkingByCode: _.debounce(
            function (query) {

                if (query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query
                    })
                    .then(response => {

                        this.invoiceDues = []
                        this.amountResidue = ''
                        this.amountReceived = ''
                        this.message = ''

                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.loadingGetMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),
        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD HH:mm:ss').toDate();
            return moment(dateToFormat).format("DD MMM YYYY HH:mm:ss")
        },
        show: function(index){
            var smsId = this.dataSms[index].smsId;
            HTTP
            .post('sms/resend', {
                tokenSms: 'kadena@2018',
                smsId: smsId
            })
            .then(response => {
                if(response.status == 200) {
                    this.$Notice.success({
                        title: "Success",
                        desc: '',
                        duration: 5
                    });
                }
            })
            .catch(e => {
                this.loadingGetMarking = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        }
    },

  created() {
    // this.getReceivable();
  }
}

</script>
<style>

</style>



// WEBPACK FOOTER //
// Log.vue?5178c2eb